module.exports = __webpack_public_path__ + "img/jpeg-icon.6a43ed58.svg";